import CameraIcon from "@assets/icons/new/camera_24px.svg?react";
import {
  ICON_LARGE_STYLE,
  SphereAvatar,
} from "@components/header/sphere-avatar";
import { UpdateProfilePictureDialog } from "@components/user-info/update-profile-picture-dialog";
import { BaseMemberProps } from "@custom-types/member-types";
import { Box } from "@mui/material";
import { useAppSelector } from "@store/store-helper";
import { loggedInUserSelector } from "@store/user/user-selector";
import { blue, neutral } from "@flat-ui";
import { getPendingUserIcon, getUserInitials } from "@utils/user-utils";
import { useState } from "react";

/** Renders SphereAvatar component with ability to update avatar */
export function SphereUpdatableAvatar({
  member,
}: BaseMemberProps): JSX.Element {
  const loggedInUser = useAppSelector(loggedInUserSelector);

  const [isAvatarHovering, setIsAvatarHovering] = useState<boolean>(false);
  const [isProfilePictureDialogOpen, setIsProfilePictureDialogOpen] =
    useState<boolean>(false);

  const isCurrentUser = member.identity === loggedInUser?.identity;

  // Return the normal SphereAvatar if member is not current user
  if (!isCurrentUser) {
    return (
      <SphereAvatar
        size="x-large"
        initials={getUserInitials(member)}
        icon={getPendingUserIcon(member, "large")}
        src={member.thumbnailUrl}
      />
    );
  }

  return (
    <>
      <Box
        component="div"
        onMouseEnter={() => setIsAvatarHovering(true)}
        onMouseLeave={() => setIsAvatarHovering(false)}
        onClick={() => setIsProfilePictureDialogOpen(true)}
        sx={{
          width: "fit-content",
          cursor: "pointer",
        }}
      >
        {isAvatarHovering ? (
          <SphereAvatar
            size="x-large"
            icon={
              <CameraIcon style={{ fill: blue[500], ...ICON_LARGE_STYLE }} />
            }
            iconColor={blue[500]}
            shouldUseSimplifiedAvatar={!isCurrentUser}
            backgroundColor={neutral[200]}
          />
        ) : (
          <SphereAvatar
            size="x-large"
            initials={getUserInitials(loggedInUser)}
            iconColor={blue[500]}
            src={loggedInUser.thumbnailUrl}
            shouldUseSimplifiedAvatar={!isCurrentUser}
            backgroundColor={neutral[400]}
          />
        )}
      </Box>

      {isProfilePictureDialogOpen && (
        <UpdateProfilePictureDialog
          user={loggedInUser}
          isDialogOpen={isProfilePictureDialogOpen}
          setIsDialogOpen={setIsProfilePictureDialogOpen}
        />
      )}
    </>
  );
}
